import immerHandleActions from 'redux/utils/immerHandleActions';
import * as actions from './actions';
import { cloneDeep } from 'lodash';

interface state extends types.redux.api.paymentType.state {}

const init: state = {
	action: 'OTHER',
};

const reducers = {
	[actions.setPaymentType](_state: any, action: actions.setPaymentTypeAction) {
		// Set the paymentType in localStorage to manage payment success and failure states on the new dashboard.
		localStorage.setItem('payment_type', action.payload.action);
		return {
			action: action.payload.action,
		};
	},
	[actions.clearPaymentType]() {
		// Clear the paymentType from localStorage to reset payment state on the new dashboard.
		localStorage.removeItem('payment_type');
		return cloneDeep(init);
	},
	'persist/REHYDRATE'(
		_state: any,
		action: { payload: { paymentType: { action: types.redux.api.paymentType.action } } }
	) {
		return {
			action: action?.payload?.paymentType?.action || 'OTHER',
		} as state;
	},
};

export default immerHandleActions(reducers, init);
